export default "__VITE_ASSET__fce97291__"